export const fieldDisplayNames: Record<string, string> = {
  // Invoice Header
  WODescription: 'Work Order Description',
  CustomerName: 'Customer Name',
  StartDate: 'Start Date',
  ModDate: 'Modified Date',
  StdJobSteps: 'Standard Job Steps',
  DisplayText: 'Display Text',
  FlatRateLaborHrs: 'Flat Rate Labor Hours',
  ShopSuppAmt: 'Shop Supply Amount',
  WOUnitNo: 'Unit Number',
  WOMeter: 'Meter',
  WOUnitModel: 'Unit Model',
  WOMeterDate: 'Meter Date',
  WOWarrantyDate: 'Warranty Date',
  WOPickupDate: 'Pickup Date',
  WODeliveryDate: 'Delivery Date',
  PORefNo: 'Purchase Order Number',
  LocTaxGroupId: 'Location Tax Group',
  WODisplayText: 'My Reference',
  NonPrintableComment: 'Non-Printable Comment',
  WOStatusId: 'Work Order Status',
  SalesPersonId: 'Sales Person',
  LocationId: 'Location',
  WOTechId: 'Technician',
  WOPriorityId: 'Priority',
  WOMeterType: 'Meter Type',
  WOUnitBaseSerial: 'Unit Base Serial',
  // Invoice Segment
  LaborRate: 'Labor Rate',
  SvcCodeId: 'Service Code',
  HasLabor: 'Has Labor',
  HasMiscCharge: 'Has Misc Charge',
  HasParts: 'Has Parts',
  LastName: 'Last Name',
  PrintableComment: 'Printable Comment',
  WOUnitDescription: 'Unit Description',
  WOUnitIsAttachment: 'Is Unit an Attachment?',
  AltContactName: 'Alternate Contact Name',
  AltContactPhone: 'Alternate Contact Phone',
  WOUnitNoSearchType: 'Unit Search Type',
  ActualHrs: 'Actual Hours',
  SegmentName: 'Segment Name',
  TotalInvoice: 'Total Invoice',
  DeliverToShippingAddress: 'Deliver to Shipping Address',
  CommittedDate: 'Committed Date',
  CommittedBy: 'Committed By',
  WoSearchType: 'Search Type',
  ClosedBy: 'Closed By',
  FinalizedDate: 'Finalized Date',
  FinalizedBy: 'Finalized By',
  VoidedDate: 'Voided Date',
  ClosedDate: 'Closed Date',
  VoidedBy: 'Voided By',
  DefaultDeliver: 'Default Delivery',
  ShippingNote: 'Shipping Note',
  SigCapType: 'Signature Capture Type',
  ActivityDate: 'AuditDate',
  CustomerNo: 'Customer Number',
  BillingAdd1: 'Billing Address Line 1',
  RequiredStartTime: 'Required Start Time',
  RequiredWaitUntilDate: 'Required Wait Until Date',
  RequiredEndTime: 'Required End Time',
  ScheduledStartTime: 'Scheduled Start Time',
  ScheduledEndTime: 'Scheduled End Time',
  ActualStartTime: 'Actual Start Time',
  Addr: 'Address',
  Addr1: 'Address',
  Addr2: 'Address',
  ActualEndTime: 'Actual End Time',
  TechComment: 'Technician Comment',
  EntBy: 'Entered By',
  EntDate: 'Entered Date',
  ModBy: 'Modified By',
  IsActive: 'Archived',
  IsClock: 'Is Clocked',
  TechId: 'Technician',
  StdJobUnitModelId: 'Standard Job Unit Model',
  JEHeaderId: 'Journal Entry Header',
  TechName: 'Technician Name',
  StdJobRecommendedHrs: 'Recommended Job Hours',
  ParentQuoteId: 'Parent Quote',
  OrigFileName: 'Original File Name',
  StartTime: 'Start Time',
  StdJobCode: 'Standard Job Code',
  WOUnitTag: 'Unit Tag',
  QuoteNo: 'Quote Number',
  BillingAdd2: 'Billing Address Line 2',
  EndTime: 'End Time',
  StdJobSource: 'Standard Job Source',
  WOUnitIsNew: 'Is New Unit',
  UnitPrice: 'Unit Price',
  StdJobDescription: 'Job Description',
  BillingPhone: 'Billing Phone',
  IsManualBillRecurr: 'Is Manual Recurring Billing',
  LineNumber: 'Line Number',
  LaborDiscPct: 'Labor Discount (%)',
  ShopSuppTaxExemptId: 'Shop Supply Tax Exempt',

  IsDefault: 'Is Default',
  QtyDelivered: 'Quantity Delivered',
  LaborDiscAmt: 'Labor Discount Amount',
  BillingZip: 'Billing Zip Code',
  BillingEmail: 'Billing Email',
  VendorQty: 'Vendor Quantity',
  BillAs: 'Bill As',
  BillingCity: 'Billing City',
  BillingState: 'Billing State',
  ShippingAddress1: 'Shipping Address Line 1',
  NetExt: 'Net Extended',
  OrderNumber: 'Order Number',
  StdJobHeaderId: 'Standard Job Header',
  CustomerId: 'Customer',
  OrderGroupId: 'Order Group',
  ActualHours: 'Actual Hours',
  FirstName: 'First Name',
  WarrSubmissionTypeId: 'Warranty Submission Type',
  QtyRecv: 'Quantity Received',
  ShopFeeAmt: 'Shop Fee Amount',
  ShopFeePct: 'Shop Fee (%)',
  MiddleName: 'Middle Name',
  MetaXML: 'Meta XML',
  MetaText: 'Meta Text',
  VendorId: 'Vendor',
  MaxShopFee: 'Maximum Shop Fee',
  POReq: 'PO Required',
  IsPublic: 'Is Public',
  TotalCost: 'Total Cost',
  OrderType: 'Order Type',
  EstimatedHours: 'Estimated Hours',
  BillingCountry: 'Billing Country',
  QtyOrdered: 'Quantity Ordered',
  SubmissionType: 'Submission Type',
  BillingCounty: 'Billing County',
  ShippingAddress2: 'Shipping Address Line 2',
  WorksheetType: 'Worksheet Type',
  OrderDiscount: 'Order Discount',
  SubmissionRefNo: 'Submission Reference Number',
  ShippingCity: 'Shipping City',
  DiscountAmt: 'Discount Amount',
  MayFlowSchedule: 'May Flow Schedule',
  ShippingState: 'Shipping State',
  DiscountPct: 'Discount (%)',
  OrderDate: 'Order Date',
  ExpectedDate: 'Expected Date',
  SubmittedDate: 'Submitted Date',
  LocationFromId: 'From Location',
  LocationToId: 'To Location',
  ExchCost: 'Exchange Cost',
  DropShipName: 'Drop Ship Name',
  DropShipAdd1: 'Drop Ship Address Line 1',
  DropShipAdd2: 'Drop Ship Address Line 2',
  ExchDiscount: 'Exchange Discount',
  DropShipCity: 'Drop Ship City',
  ExchangeRate: 'Exchange Rate',
  FollowUp: 'Follow Up',
  DropShipState: 'Drop Ship State',
  DropShipZip: 'Drop Ship Zip',
  DropShipCountry: 'Drop Ship Country',
  InterfaceMeta: 'Interface Metadata',
  ProcessedDate: 'Processed Date',
  DropShipEmailAddr: 'Drop Ship Email',
  DropShipPhone: 'Drop Ship Phone',
  InterfaceText: 'Interface Text',
  OwnerId: 'Owner',
  ExchangeRateId: 'Exchange Rate',
  AltTaxGroupId: 'Alternate Tax Group',
  InvoiceFormat: 'Invoice Format',
  WOEstimate: 'Work Order Estimate',
  WOUnitId: 'Work Order Unit',
  ShippingTaxGroupId: 'Shipping Tax Group',
  ShippingPhone: 'Shipping Phone',
  DiscountMarkup: 'Discount Markup',
  ShippingCountry: 'Shipping Country',
  UsePrePrintedPaper: 'Use Pre-Printed Paper',
  NonLaborTaxExemptId: 'Non-Labor Tax Exempt',
  ZoneId: 'Zone',
  UseAltTax: 'Use Alternate Tax',
  LaborTaxExemptId: 'Labor Tax Exempt',
  WeightKgs: 'Weight (kg)',
  JurisdictionDisplayText: 'Jurisdiction',
  TaxableAmount: 'Taxable Amount',
  NonTaxableAmount: 'Non Taxable Amount',
  TotalSales: 'Total Sales',
  TotalTax: 'Total Tax',
  TotalTrade: 'Total Trade',
  AltTax: 'Alternate Tax',
  RentalUseTax: 'Rental Uses Tax',
  PrintInvAs: 'Print Invoice As',
  TemplateId: 'Template',
  SegmentId: 'Segment',
  IsComplete: 'Is Complete?',
  EnteredBy: 'Created By',
  EnteredDate: 'Created Date',
  ModifiedBy: 'Modified By',
  ModifiedDate: 'Modified Date',
  CustomerAltAddressId: 'Customer Alternate Address',
  InvoiceLaborAdjustmentCode: 'Labor Adjustment Code',
  TimeOn: 'Time On',
  TimeOff: 'Time Off',
  ElapsedHours: 'Elapsed Hours',
  EmailTypeId: 'Email Type',
  DefSalespersonId: 'Default Salesperson',
  TaxExemptId: 'Tax Exempt',
  SpecialPricingId: 'Special Pricing',
  TaxGroupOverrideId: 'Tax Group Override',
  TaxGroupId: 'Tax Group',
  ReportId: 'Report',
  MfgId: 'Mfg',
  SortKey: 'Sort Key',
  DeptId: 'Department',
  AccountId: 'Account',
  ChartId: 'Chart',
  JobInstanceHostId: 'Job Instance',
  //AppUser DefaultLocationId FK needs to be resolved
  DefaultLocationId: 'Location',
  Sortkey: 'Sort Key',
  UserId: 'User',
  RoleId: 'Role',
  JobSettingsId: 'Job Settings',
  //JobScheduler this FK needs to be resolved
  Priority: '',
  //JobSchedulerSetting
  //ReportedDashboardWebLink Location needs to be resolved
  DashboardId: 'Dashboard',
  PermissionId: 'Permission',
  SegmentTaskId: 'Segment Task',
  TechnicianId: 'Tech',
  //UnitDepreciationSchedule: UnitId needs to be resolved
  //UnitCostGroupId, DepreciationTypeId, DepreciationHeaderId
  UnitId: 'Unit',
  GLDate: 'GL Date',

  ProductLineId: 'Product Line',
  UnitCategoryCode: 'Category Code',
  //UnitCategory: Need to resolve the followings:
  // InventoryAcctId,
  // InventoryDeptId,
  // UnitSalesAcctId,
  // UnitSalesDeptId,
  // UnitCostAcctId, UnitCostDeptId,
  // UnitDiscountAcctId,
  // UnitDiscountDeptId, UnitOverallowAcctId,
  //UnitOverallowDeptId, ClearingAcctId, ClearingDeptId
  InventoryAcctId: 'Inventory Account',
  InventoryDeptId: 'Inventory Department',
  UnitSalesAcctId: 'Unit Sales Account',
  UnitSalesDeptId: 'Unit Sales Department',
  UnitCostAcctId: 'Unit Cost Account',
  UnitCostDeptId: 'Unit Cost Department',
  UnitDiscountAcctId: 'Unit Discount Account',
  UnitDiscountDeptId: 'Unit Discount Department',
  UnitOverallowAcctId: 'Unit Overallow Account',
  UnitOverallowDeptId: 'Unit Overallow Department',
  ClearingAcctId: 'Clearing Account',
  ClearingDeptId: 'Clearing Department',
  //TeamUser: AppUserId, TeamId
  AppUserId: 'App User',
  TeamId: 'Team',
  //TaskAssignment: Need to remove 'SourceId, TargetId,
  //Resolve followings: AssignedTeamId, MonitoredByUserId, StatusUserId
  AssignedTeamId: 'Assigned Team',
  MonitoredByUserId: 'Monitored By',
  StatusUserId: 'Status User',
  //UserPreferences: Resolve AppUserId, LocationId
  //ServiceContractRateMatrixItem: Resolve ServiceContractRateMatrixId
  ServiceContractRateMatrixId: 'Service Contract Rate Matrix',
  //ServiceContractRateMatrix: Resolve LocationId
  //ServiceContractGroupRateMatrix: Resolve ServiceContractGroupID,
  // ServiceContractRateMatrixId
  ServiceContractGroupID: 'Service Contract Group',
  ServiceContractRateMatrixID: 'Service Contract Rate Matrix',
  //ServiceContractGroup: Resolve ,
  // , RevenueDeptId, DiscountDeptId, LocationID
  DiscountAccountID: 'Discount Account',
  RevenueAccountID: 'Revenue Account',
  RevenueDeptID: 'Revenue Department',
  DiscountDeptID: 'Discount Department',
  LocationID: 'Location',

  RecvPaymentMethodId: 'Recv Payment Method',
  APVoucherPaymentMethodId: 'APVoucher Payment Method',
  WarrCreditSalesPersonId: 'Warranty Credit Sales Person',
  RentalGroupId: 'Rental Group',
  //RentalGroupMatrix: Resolve RentalRateMatrixId
  RentalRateMatrixId: 'Rental Rate Matrix',
  //RentalGroup: Resolve the followings :
  RentalCOSAcctId: 'Rental Cost Account',
  RentalCOSDeptId: 'Rental Cost Department',
  RentalDiscAcctId: 'Rental Discount Account',
  RentalDiscDeptId: 'Rental Discount Department',
  RentalRevAcctId: 'Rental Revenue Account',
  RentalRevDeptId: 'Rental Revenue Department',
  UnitCostGroupId: 'Unit Cost Group',
  UnitGroupId: 'Unit Group',
  //PaymentSettingUnprocessedCredit: Update Trigger for
  // CCLast4
  // /ExptDateReq
  // /AuthNoReq for Yes/No
  PaymentMethodId: 'Payment Method',
  //PaymentSettingUnit:
  //Update trigger for RequireUnitCostGroup Yes/No

  //PaymentSettingGeneralLedger:
  //Update trigger for
  // Show Check Ref No,
  // Ref No Min Len  Yes/No

  //Payment Setting Deposit
  //Update Trigger for Yes/No

  //PaymentMethodPayableVoucherType:
  //DetailId, AccountId, DepartmentId
  DetailId: 'Detail',

  //PaymentMethodPayableVoucher:
  //ShowRefNo, RefNoMinLen, PmtVendorId, PurchVendorId, Team, MonitorUserId,
  //IsWarranty for Yes/No
  //RequiresWarrClaim for Yes/No
  //

  //PaymentMethod:
  //ParentPaymentMethodId,
  //Restricted for Yes/No
  //AcctId, DepartmentId,

  //PartManufacturerReturn
  //MfgId

  //PartManufacturerPromoDetail:
  //MfgPromoId, MfgId, OEMMfgId,

  //PartBinZone
  //LocationId,

  POSAccountId: 'POS Account',
  POSDeptId: 'POS Department',
  WOAccountId: 'WO Account',
  WODeptId: 'WO Department',
  POSDiscountAccountId: 'POS Discount Account',
  POSDiscountDeptId: 'POS Discount Department',
  WODiscountAccountId: 'WO Discount Account',
  WODiscountDeptId: 'WODiscount Department',
  //MiscCharges
  //Resolve Taxable  for yes/no
  //TaxExempt for yes/no

  //JournalEntryTemplateHeader
  //Resolve PeriodId, CategoryId, DocumentStatusId,
  PeriodId: 'Period',
  CategoryId: 'Category',
  DocumentStatusId: 'Document Status',
  JEMemo: 'Journal Entry Memo',
  JEDate: 'Journal Entry Date',

  //JournalEntryLine
  //JournalEntryHeaderId, AcctId,
  // DeptId,
  // Location,
  // BankRecHeaderId
  //Remove TargetId, SourceId, HashValue
  DepartmentId: 'Department',
  //JournalEntryHeader
  //Resolve PeriodId, CategoryId, OwnerId, DocumentStatusId, ReversalFromJEId,
  //Remove: HashValue
  JENumber: 'Journal Entry Number',

  //EmployeeSchedule
  //REsolve: AppUserId

  //EmployeeGroupUserMap:
  //Resolve EmpGroupId, AppUserId
  EmpGroupId: 'Employee Group',

  //EmailTemplates
  //Resolve CommunicationCategoryId
  CommunicationCategoryId: 'Communication Category',

  //PartManuFacturer
  InventoryAccountId: 'Inventory Account',

  //AccountListDetail:
  //Resolve AccountListHeaderId, DepartmentId, LocationId,
  //Remove TargetId, AltTargetId
  AccountListHeaderId: 'Account List',

  //BankAccount
  //Account, Department,
  // Location,
  // ExchangeAcctId,
  // ExchangeDeptId,
  // ExchangeLocId,
  // ExchangeVarAcctId,
  // ExchangeVarDeptId

  ExchangeAcctId: 'Exchange Account',
  ExchangeDeptId: 'Exchange Department',
  ExchangeLocId: 'Exchange Location',
  ExchangeVarAcctId: 'Exchange Variable Account',
  ExchangeVarDeptId: 'Exchange Variable Department',

  //ChartExcludeLocation
  //Resolve: ChartID
  ChartID: 'Chart',

  //Communication
  //Resolve CategoryId,
  //Remove: OwnerId, SourceId, TargetId

  //ReviewInvoiceWorkflow
  //Resolve ReviewMonitorUserId
  ReviewMonitorUserId: 'Review Monitor User',

  TaxJurisdictionId: 'Tax Jurisdiction',
  //Jurisdiction
  //Remove CalcLevel
  //SalesTaxGroupJurisdiction
  //Resolve: TaxGroupJurisdictionId
  TaxGroupJurisdictionId: 'Tax Group Jurisdiction',
  //ReviewInvoiceWorkflow
  //Resolve: ReviewTeamId

  NewInvDocSalesPersonId: 'New Invoice Doc Salesperson',
  OptionId: 'Option',
  //LocationPaymentMethod
  //Resolve: Default
  DepartmentID: 'Department',

  //Location:
  //Resolve: LocationId, TaxExemptId, DefaultPOSCustomerId
  GLNO: 'GL No',
  GLNo: 'GL No',
  TaxExempt: 'Tax Exempt',
  DefaultPOSCustomerId: 'Default POS Customer',
  //CityState: Resolve StateId
  StateId: 'State',

  // Priority transactional FK fields (updated audit triggers)
  WarrRequestId: 'Warranty Request',
  WarrSegmentId: 'Warranty Segment',
  ParentContractId: 'Parent Contract',
  ResvGroupId: 'Reservation Group',
  ParentInvoiceDocId: 'Parent Invoice',
  WriteOffDocId: 'Write-Off Invoice',
  //WarrSubmissionTypeId: 'Warranty Submission Type',
  ResponsibleTechId: 'Responsible Technician',
  RecvPmtMethodId: 'Receive Payment Method',
  RecvROAPmtMethodId: 'Receive ROA Payment Method',
  APVouchPmtMethodId: 'AP Voucher Payment Method',
  InvoiceDocId: 'Invoice',
  PaymentId: 'Payment',
  LaborAdjCodeId: 'Labor Adjustment Code',
  ServiceContractID: 'Service Contract',
  UnitID: 'Unit',
  ItemID: 'Invoice Detail',
  OrigSegmentId: 'Original Segment',
  OrigDetailItemId: 'Original Detail Item',
  OrigWIPId: 'Original WIP',
  LocationIdentity: 'Location',
  DestinationLocationId: 'Destination Location',
  SourceLocationId: 'Source Location',

  // Remaining batch triggers (commit 0273ba31)
  ApplicableQuotedUnitId: 'Applicable Quoted Unit',
  ApplicableUnitId: 'Applicable Unit',
  AppliesToFinanceChargeId: 'Applies To Finance Charge',
  AppliesToInvoiceDocId: 'Applies To Invoice',
  AttachmentId: 'Attachment',
  BillToCustomerId: 'Bill To Customer',
  CheckRunId: 'Check Run',
  ChildPartId: 'Child Part',
  ClosedDocId: 'Closed Invoice',
  CommodityIdentity: 'Commodity',
  CorePartPriceFileId: 'Core Part Price File',
  FCDeptId: 'Finance Charge Department',
  GeneralWOAccountId: 'General WO Account',
  GeneralWODeptId: 'General WO Department',
  InvDocId: 'Invoice',
  KubotaInvoiceHeaderId: 'Kubota Invoice',
  LaborWOAccountId: 'Labor WO Account',
  LaborWODeptId: 'Labor WO Department',
  ManufacturerIdentity: 'Manufacturer',
  ManufacturerPromotionIdentity: 'Manufacturer Promotion',
  MfgFromId: 'Manufacturer From',
  MfgToId: 'Manufacturer To',
  MiscChargeId: 'Miscellaneous Charge',
  OrderCodeGroupIdentity: 'Order Code Group',
  OrigReturnId: 'Original Return',
  ParentOrderId: 'Parent Order',
  ParentPartId: 'Parent Part',
  PartGroupIdentity: 'Part Group',
  PartListIdentity: 'Part List',
  PartsWOAccountId: 'Parts WO Account',
  PartsWODeptId: 'Parts WO Department',
  PaymentMehodId: 'Payment Method',
  ProvidedUnitId: 'Provided Unit',
  RentHubLineTypeId: 'RentHub Line Type',
  RentHubMiscChargeId: 'RentHub Misc Charge',
  RequestedUnitId: 'Requested Unit',
  ReturnCodeIdentity: 'Return Code',
  SeasonIdentity: 'Season',
  SerialTypeId: 'Serial Type',
  SourceUnitTransferHeaderID: 'Source Unit Transfer',
  //TeamId: 'Team',
  UnitTemplateId: 'Unit Template',
  UnitTransferHeaderId: 'Unit Transfer Header',
  UnitTransferStatusId: 'Unit Transfer Status',
  VendorTemplateHeaderId: 'Vendor Template',
  VoucherId: 'Voucher',
  WarrantyClaimId: 'Warranty Claim',
  WorkOrderId: 'Work Order',
  PartId:'Part',
  TechnicianIdentity:"Technician",
  StatusIdentity:"Status",
};

export default fieldDisplayNames;
